import { ModuleManager, SectionList } from "@module-system";

import component from "./Components/SwitchCamera.vue";
import CommonConditions from "@lib/commonConditions";
import { ClientJS } from "clientjs";

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "MobileWebSwitchCamera",
  version: "1.0.0",
  register() {
    ModuleManager.addViewModule({
      key: "mobile-web-switch-camera",
      section: SectionList.AbsoulteBottom,
      ViewComponent: component,
      Condition: (rtcId) => {
        const isAgent = CommonConditions.isAgent(rtcId);
        const clientJs = new ClientJS();
        
        return !isAgent && clientJs.isMobile();
      }
    });

  },
};
export default module;